/* Sección de escasez + urgencia: contador y segmentación por campaña.
   (2026-08-16; modo "sesion" 08-17; segmentación por ?ref= 08-17.)

   TRES comportamientos, según cómo esté configurada la sección:

   - Segmentada (`data-urg-gate`): la sección viene OCULTA del server y
     solo se enseña a quien llegó con ?ref=<campaña> y sigue dentro de su
     ventana (24 h por defecto) desde la PRIMERA visita atribuida. Aquí el
     contador se alinea a esa ventana: cuenta lo que de verdad le queda y,
     al llegar a cero, la sección entera desaparece. No se reinicia — si
     no compró en su ventana, se acabó.

   - "fecha": cuenta atrás a una fecha real. A cero, la fila se esconde.

   - "sesion" sin segmentar: ventana por visitante que SÍ se reinicia
     (el test de impacto que pidió Mau). Se conserva tal cual.

   La atribución la escribe js-skindion-atribucion.js (cookie skd_ref,
   cargado con defer en el <head>, así que ya corrió cuando llega esto).
   Aun así se lee la cookie directamente y no una variable global: si por
   lo que sea el otro script no cargó, aquí no se enseña nada. */
(function () {
  /* La sección puede instanciarse dos veces en la plantilla (urgencia + escasez) y cada
     una incluye este script: el segundo no debe volver a inicializar timers ni cookies. */
  if (window.__skdUrgenciaInit) return;
  window.__skdUrgenciaInit = true;
  'use strict';

  var COOKIE_TIMER = 'skd_urg_fin';
  var COOKIE_REF = 'skd_ref';
  var DIAS_COOKIE = 30;

  function leerCookie(nombre) {
    var partes = ('; ' + document.cookie).split('; ' + nombre + '=');
    if (partes.length !== 2) return null;
    return decodeURIComponent(partes.pop().split(';').shift() || '');
  }

  function escribirCookie(nombre, valor) {
    try {
      var caduca = new Date(Date.now() + DIAS_COOKIE * 86400000).toUTCString();
      document.cookie = nombre + '=' + valor + '; expires=' + caduca + '; path=/; SameSite=Lax';
    } catch (e) {}
  }

  /* { ref, desde } de la cookie de atribución, o null. */
  function atribucion() {
    var crudo = leerCookie(COOKIE_REF);
    if (!crudo) return null;
    var t = crudo.split('|');
    if (!t[0]) return null;
    return { ref: t[0], desde: parseInt(t[1], 10) || 0 };
  }

  /* ---- Segmentación ------------------------------------------------
     Dos públicos, excluyentes entre sí:

     - "solo_advertorial": la ve quien llegó con ?ref= y sigue dentro de
       su ventana. Devuelve el fin de esa ventana para que el contador se
       alinee a ella.
     - "solo_normal": la ve TODO EL MUNDO MENOS ese público, así que no
       hay ventana que devolver (devuelve true).

     En ambos casos, enseñar la sección es efecto secundario. Devuelve
     null si esta persona no debe verla. */
  function resolverGate(caja) {
    var publico = caja.getAttribute('data-urg-publico') || 'solo_advertorial';
    var esperado = (caja.getAttribute('data-urg-gate') || '').toLowerCase();
    var horas = parseFloat(caja.getAttribute('data-urg-ventana')) || 24;
    var a = atribucion();

    var esDeCampana = !!a && a.ref.toLowerCase() === esperado && !!a.desde &&
      (a.desde + horas * 3600000) > Date.now();

    if (publico === 'solo_normal') {
      if (esDeCampana) return null;       // ese ya tiene la suya
      caja.hidden = false;
      return true;                        // sin ventana: no caduca
    }

    if (!esDeCampana) return null;
    caja.hidden = false;
    return a.desde + horas * 3600000;
  }

  function initTimer(el, finDeGate) {
    var fila = el.closest('[data-urg-fila]');
    var caja = el.closest('.urg');
    var esSesion = el.getAttribute('data-urg-modo') === 'sesion';
    var horas = parseFloat(el.getAttribute('data-urg-horas')) || 12;
    var fin;

    if (typeof finDeGate === 'number') {
      /* Segmentada por campaña: manda la ventana de esa persona. */
      fin = finDeGate;
    } else if (esSesion) {
      var ventana = horas * 3600000;
      var guardado = parseInt(leerCookie(COOKIE_TIMER), 10);
      if (!isNaN(guardado) && guardado > Date.now() && guardado <= Date.now() + ventana) {
        fin = guardado;
      } else {
        fin = Date.now() + ventana;
        escribirCookie(COOKIE_TIMER, String(fin));
      }
    } else {
      var fecha = new Date(el.getAttribute('data-urg-fin') || '');
      if (isNaN(fecha.getTime())) return;
      fin = fecha.getTime();
    }

    function pinta() {
      var resta = Math.floor((fin - Date.now()) / 1000);

      if (resta <= 0) {
        if (typeof finDeGate === 'number') {
          /* Se acabó la ventana de la campaña: fuera la sección entera. */
          if (caja) caja.hidden = true;
          clearInterval(intervalo);
          return;
        }
        if (esSesion) {
          fin = Date.now() + horas * 3600000;
          escribirCookie(COOKIE_TIMER, String(fin));
          resta = Math.floor((fin - Date.now()) / 1000);
        } else {
          if (fila) fila.hidden = true;
          if (caja && !caja.querySelector('.urg__fila:not([hidden])')) caja.hidden = true;
          clearInterval(intervalo);
          return;
        }
      }

      var h = Math.floor(resta / 3600);
      var m = Math.floor((resta % 3600) / 60);
      var s = resta % 60;
      el.textContent = h + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
    }

    var intervalo = setInterval(pinta, 1000);
    pinta();
  }

  var cajas = document.querySelectorAll('.urg');
  for (var i = 0; i < cajas.length; i++) {
    var caja = cajas[i];
    var finDeGate = null;

    if (caja.hasAttribute('data-urg-gate')) {
      finDeGate = resolverGate(caja);
      if (!finDeGate) continue;   // no es su público: se queda oculta
    }

    var timers = caja.querySelectorAll('[data-urg-timer]');
    for (var j = 0; j < timers.length; j++) initTimer(timers[j], finDeGate);
  }
})();
